'use strict'

import { CertificatesStringConstructor } from './certificatesStringConstructor'

const defaultConstructorArray = [
  'CN=',
  async (certObj) => await certObj.getSubjectCommonName(),
  '; Выдан: ',
  async (certObj) => await certObj.getValidFromDate(),
  '; Алгоритм ключа: ',
  async (certObj) => await certObj.getAlgorithmName()
]

export class Certificates {
  constructor ({ certListBoxId, Signer, stringConstructor }) {
    this.certListBoxId = certListBoxId

    this.stringConstructor = stringConstructor
    this.Signer = Signer

    this.certificates = []
    this.counter = 0

    this.init()
  }

  async init () {
    const lst = document.querySelector(`#${this.certListBoxId}`)
    lst.innerHTML = ''
    // eslint-disable-next-line no-undef
    const oStore = await cadesplugin.CreateObjectAsync('CAdESCOM.Store')
    await oStore.Open()

    const CertificatesObj = await oStore.Certificates
    const certCnt = await CertificatesObj.Count
    const selected = certCnt === 1
    for (let i = 1; i <= certCnt; i++) {
      const cert = await CertificatesObj.Item(i)
      this.certificates[i - 1] = cert
      this.Signer.certificates[i - 1] = cert

      const validFrom = await cert.ValidFromDate
      const validTo = await cert.ValidToDate

      const certObj = new CertificateObj(cert, validFrom, validTo, this.stringConstructor)

      const oOpt = document.createElement('option')
      oOpt.text = await certObj.GetCertString()
      oOpt.selected = selected

      oOpt.value = this.counter
      this.counter++

      lst.options.add(oOpt)
    }

    await oStore.Close()
  }
}

export class CertificateObj {
  constructor (
    certObj,
    ValidFromDate,
    ValidToDate,
    stringConstructor = new CertificatesStringConstructor({
      constructArray: defaultConstructorArray
    })
  ) {
    this.cert = certObj
    this.stringConstructor = stringConstructor
    if (certObj) {
      this.certFromDate = new Promise(resolve => {
        certObj.ValidFromDate.then(ValidFromDate => {
          resolve(new Date(ValidFromDate))
        })
      })
      this.certTillDate = new Promise(resolve => {
        certObj.ValidToDate.then(ValidToDate => {
          resolve(new Date(ValidToDate))
        })
      })
    }
  }

  check (digit) {
    return (digit < 10) ? '0' + digit : digit
  }

  checkQuotes (str) {
    var result = 0
    var i = 0
    for (i; i < str.length; i++) {
      if (str[i] === '"') {
        result++
      }
    }
    return !(result % 2)
  }

  extract (from, what, alternativeWhat = []) {
    let certName = ''

    let begin = from.indexOf(what)
    if (begin === -1) {
      for (const el of alternativeWhat) {
        if (from.indexOf(el) >= 0) {
          begin = from.indexOf(el)
          break
        }
      }
    }

    if (begin >= 0) {
      let end = from.indexOf(', ', begin)
      while (end > 0) {
        if (this.checkQuotes(from.substr(begin, end - begin))) {
          break
        }
        end = from.indexOf(', ', end + 1)
      }
      certName = (end < 0) ? from.substr(begin) : from.substr(begin, end - begin)
    }

    return certName
  }

  extractPure (from, what) {
    return this.extract(from, what).replace(what, '')
  }

  DateTimePutTogether (certDate) {
    return this.check(certDate.getUTCDate()) + '.' + this.check(certDate.getUTCMonth() + 1) + '.' + certDate.getFullYear() + ' ' +
      this.check(certDate.getUTCHours()) + ':' + this.check(certDate.getUTCMinutes()) + ':' + this.check(certDate.getUTCSeconds())
  }

  async GetCertString () {
    this.stringConstructor.certificateObject = this

    return await this.stringConstructor.construct()
  };

  async GetCertFromDate () {
    return this.DateTimePutTogether(await this.certFromDate)
  };

  async GetFriendlyName () {
    const publicKey = await this.cert.PublicKey()
    const algorithm = await publicKey.Algorithm
    return await algorithm.FriendlyName
  }

  async getIssuerCommonName () {
    return await this.extractPure(await this.cert.IssuerName, 'CN=')
  }

  async getIssuerEmail () {
    return await this.extractPure(await this.cert.IssuerName, 'E=')
  }

  async getIssuerCountryName () {
    return await this.extractPure(await this.cert.IssuerName, 'C=')
  }

  async getIssuerLocality () {
    return await this.extractPure(await this.cert.IssuerName, 'L=')
  }

  async getIssuerOrganization () {
    return await this.extractPure(await this.cert.IssuerName, 'O=')
  }

  async getSubjectCommonName () {
    return await this.extractPure(await this.cert.SubjectName, 'CN=')
  }

  async getSubjectEmail () {
    return await this.extractPure(await this.cert.SubjectName, 'E=')
  }

  async getSubjectCountryName () {
    return await this.extractPure(await this.cert.SubjectName, 'C=')
  }

  async getSubjectStateOrProvinceName () {
    return await this.extractPure(await this.cert.SubjectName, 'S=')
  }

  async getSubjectLocality () {
    return await this.extractPure(await this.cert.SubjectName, 'L=')
  }

  async getSubjectOrganization () {
    return await this.extractPure(await this.cert.SubjectName, 'O=')
  }

  async getSubjectOrganizationalUnit () {
    return await this.extractPure(await this.cert.SubjectName, 'OU=')
  }

  async getValidFromDate () {
    return this.DateTimePutTogether(await this.certFromDate)
  }

  async getValidToDate () {
    return this.DateTimePutTogether(await this.certTillDate)
  }

  async getVersion () {
    return await this.cert.Version
  }

  async getAlgorithmName () {
    return await this.GetFriendlyName()
  }
}
